/**
 * This method moves item from fromIndex to toIndex in array
 *
 * @param array array to modify
 * @param fromIndex current index of item
 * @param toIndex desired index of item
 */
// https://linear.app/air/issue/ENG-124/update-moveitemtoindex-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function moveItemToIndex(array: any[], fromIndex: number, toIndex: number) {
  const itemToMove = array[fromIndex];

  array.splice(fromIndex, 1);
  array.splice(toIndex, 0, itemToMove);

  return array;
}
